module.exports = __webpack_public_path__ + "static/media/b-sci-major-32_LR.ebc0bad6.jpg";